import moment from 'moment';

export class PearlsPlanningEventType {
    id: number;
    name: string;
}

export class PearlsPlanningEvent {
    id: number;
    startDate: Date;
    startHour: string;
    duration: number;
    allDay: boolean;
    eventType: number;
    description: string;
    author: string;
    salesreps: Array<number>;
    allowToCancel: boolean;
    allowToDelete: boolean;
    allowToDuplicate: boolean;
    allowToUpdate: boolean;
        
    static FromJson(o: any): PearlsPlanningEvent {
        let e = new PearlsPlanningEvent();
        let date = moment(o.start);
        if(date){        
            e.id = o.id;
            e.startDate = date.toDate();
            e.startHour = date.format('HH:mm');
            e.duration = o.duration;
            e.eventType = o.eventsType;
            e.allDay = o.fullDay;
            e.description = o.description;
            e.author = o.author;
            e.salesreps = o.salesreps;
            e.allowToCancel = o.allowToCancel;
            e.allowToDelete = o.allowToDelete;
            e.allowToDuplicate = o.allowToDuplicate;
            e.allowToUpdate = o.allowToUpdate;           
        }
        return e;
    }
}


export class PearlsPlanningEventDto {
    id: number;
    start: number;
    duration: number;
    refDate: number;
    description: string;
    salesreps: Array<number>;
    fullDay: boolean;
    eventsType: number;
    author: string = '';
    editable: boolean = true;
}